import { render, staticRenderFns } from "./BillingPlanDetailsPage.vue?vue&type=template&id=f668de56&scoped=true&"
import script from "./BillingPlanDetailsPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BillingPlanDetailsPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BillingPlanDetailsPage.vue?vue&type=style&index=0&id=f668de56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f668de56",
  null
  
)

export default component.exports